module.exports = __webpack_public_path__ + "img/image8.db3b4881.webp";